import React from "react";
import Grid from "@mui/material/Grid";
import styled from "@mui/material/styles/styled";
const StyleAddons = styled("div")(() => {
    return {
        ".addon-title": {
            fontFamily: "'Anton', sans-serif",
            fontWeight: "bold",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: 1.1,
            letterSpacing: "normal",
            textAlign: "left",
            color: "#000",
            margin: "0",
            fontSize: 36,
            marginBottom: 15,
        },
        ".addon_status": {
            color: "#fff",
            width: 65,
            height: 16,
            fontFamily: "Roboto",
            fontSize: 12,
            fontWeight: "normal",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: 1.33,
            letterSpacing: 0.4,
            textAlign: "left",
            padding: "5px 10px",
            borderRadius: 4,
        },
        ".addon_inactive": {
            backgroundColor: "#eb5757",
        },
        ".addon_active": {
            backgroundColor: "#27ae60",
        },
        ".addon_label": {
            fontFamily: "Roboto",
            fontSize: 14,
            fontWeight: "normal",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: "normal",
            textAlign: "left",
            color: "#454d58",
            margin: "20px 0 0px 0",
        },
        ".addon_value": {
            marginTop: 0,
        },
    };
});
export const Addons = (props) => {
    return (React.createElement(StyleAddons, null,
        React.createElement("h1", { className: "addon-title" }, props.title),
        props.active ? (React.createElement(Active, { membersRolled: props.membersRolled, effectiveDate: props.effectiveDate, fee: props.fee })) : (React.createElement(Inactive, null))));
};
const MontlyFee = ({ fee }) => (React.createElement("div", { className: "MontlyFee" },
    React.createElement("p", { className: "addon_label" }, "Add-On Monthly Fee"),
    React.createElement("p", { className: "addon_value" },
        React.createElement("b", null,
            "$",
            fee || 25),
        " ",
        React.createElement("span", { className: "addon_label" }, "(Family Total)"))));
const Inactive = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "addon_status addon_inactive" }, "Inactive"),
        React.createElement(MontlyFee, null)));
};
const Active = (props) => {
    var _a, _b;
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "addon_status addon_active" }, "Active"),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement("p", { className: "addon_label" }, "Members Enrolled"), (_a = props.membersRolled) === null || _a === void 0 ? void 0 :
                _a.map((data) => (React.createElement("b", null, data)))),
            React.createElement(Grid, { item: true, xs: 12, md: 6 },
                React.createElement("p", { className: "addon_label" }, "Effective Date"), (_b = props.effectiveDate) === null || _b === void 0 ? void 0 :
                _b.map((data) => (React.createElement("b", null, data)))),
            React.createElement(Grid, { className: "MontlyFee", item: true, xs: 12, sx: { paddingTop: "0px !important" } },
                React.createElement(MontlyFee, { fee: props.fee })))));
};
